<template>
  <div class="product-detail-box" v-if="detail && detail.length">
    <div class="product-detail" v-for="(item, index) in detail">
      <div class="detail-box">
        <div class="title-box" v-on:click="toggleDetail(index, $event)" >
          <div class="title">{{item.title}}</div>
          <div v-if="!item._spreadAll" class="arrow" :class="[ item._spread? 'arrow-up' : 'arrow-down']"></div>
        </div>
        <div class="content-box" :class="{ 'spread' : (item._spreadAll || item._spread) }" >
            <div class="content" v-for="itemContent in item._content">{{itemContent}}</div>
        </div>
      </div>
    </div>
    <!-- <div class="line m-t"></div> -->
  </div>
</template>
<script>
export default {
  props:{
    detail: {
      type: Array
    }
  },

  methods: {
    toggleDetail (index, event) {
      var item = this.detail[index]
      if(item._spreadAll){
        return
      }
      item._spread = !item._spread
      this.detail.splice(index,1,item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// desc.vue?6633a44c